"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodes = void 0;
exports.errorCodes = {
    WALLET_SETTING_ADDRESS_INVALID_ID: "errorGeneric",
    WALLET_SETTING_ADDRESS_CANNOT_REMOVE_PRIMARY: "errorAddressRemovePrimary",
    WALLET_SETTING_ADDRESS_CANNOT_REMOVE_BILLING: "errorAddressRemoveBilling",
    WALLET_SETTING_ADDRESS_CANNOT_REMOVE_BILLING_CREDIT: "errorAddressRemoveBillingPPCredit",
    WALLET_SETTING_ADDRESS_MISSING_COUNTRY: "errorAddressCountryMissing",
    WALLET_SETTING_ADDRESS_MISSING_CITY: "errorAddressCityMissing",
    WALLET_SETTING_ADDRESS_MISSING_ADDRESS: "errorAddressStreetMissing",
    WALLET_SETTING_ADDRESS_COUNT_EXCEEDED: "errorAddressMaximumReached",
    WALLET_SETTING_ADDRESS_ALREADY_EXISTS: "errorAddressExists",
    WALLET_SETTING_ADDRESS_COMBINATION_WRONG: "errorAddressCombinationWrong",
    WALLET_SETTING_ADDRESS_CANNOT_REMOVE_BUSINESS: "errorAddressRemoveBusiness",
    WALLET_SETTING_NO_CHANGE: "errorNoChange",
};
